<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>대리결제</h3>
				<h4>이러한 사업자 회원님들이 <br class="visible-xs">이용하시면 좋아요!</h4>
			</div>
			<div class="summary text-center mb100">
				- 1688, 제조공장 등 직접결제가 원할하지 않은 사업자 회원<br>
				- LCL 등 대량의 수입이 필요하신 사업자 회원<br>
				- 다수의 중국 판매자에게 결제가 필요하신 사업자 회원<br>
				- 외환송금을 받지 못하는 중국판매자와의 원활한 거래가능<br>
				- 합법적인 해외송금(인보이스를 통한 T.T 송금지원)으로 매입 및 외환거래의 투명성 제공
			</div>
			
			<div class="unit mb100">
				<div class="title mb30">대리결제 간단소개</div>
				<el-row class="unit-list">
					<el-col :xs="24" :sm="4">
						<div class="type-card">
							<div class="card-head">1. 상품선정</div>
							<div class="card-body">
								<div class="img-box"><img src="../../assets/list/document_1688_guide_img1.png" alt=""></div>
								<p>구매상품을 선정합니다.</p>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="4">
						<div class="type-card">
							<div class="card-head">2. 인보이스 발행</div>
							<div class="card-body">
								<div class="img-box"><img src="../../assets/list/document_1688_guide_img2.png" alt=""></div>
								<p>
									대리결제 하실 내용으로<br>
									고로켓고에게 인보이스 발행 요청
								</p>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="4">
						<div class="type-card">
							<div class="card-head">3. 은행송금</div>
							<div class="card-body">
								<div class="img-box"><img src="../../assets/list/document_1688_guide_img3.png" alt=""></div>
								<p>
									발급받으신 인보이스로<br>
									결제금액을 은행을 통해<br>
									고로켓고 현지 협력 법인에게 송금
								</p>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="4">
						<div class="type-card">
							<div class="card-head">4. 상품구매</div>
							<div class="card-body">
								<div class="img-box"><img src="../../assets/list/document_1688_guide_img4.png" alt=""></div>
								<p>
									고로켓고 현지 협력 법인에게 USD로<br>
									입금된 비용을 위안화로 환전 후<br>
									고로켓고 회원님 계정으로<br>
									위안화 예치금으로 예치 후<br>
									상품비용 대리결제
								</p>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="4">
						<div class="type-card">
							<div class="card-head">5. 고로켓고 배송</div>
							<div class="card-body">
								<div class="img-box"><img src="../../assets/list/document_1688_guide_img5.png" alt=""></div>
								<p>
									구매 완료한 상품<br>
									현지 도착 후 한국으로 배송
								</p>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			
			<div class="unit mb100">
				<div class="title mb30">대리결제 이용안내</div>
				<div class="text-box">
					<p>
						1688 계정은 타오바오 계정으로 같이 사용하실 수 있습니다.<br>
						1688 L6 레벨 계정이어도 전품목 5% 할인은 아닙니다.<br>
						1688 PLUS 계정도 5% 할인 등 다양한 혜택이 있습니다.<br>
						대리결제 서비스는 고로켓고의 배송서비스를 이용하시는 사업자회원에게만 서비스 제공됩니다.
					</p>
					<ul class="dot-list mb50">
						<li>인보이스 신청 후 고로켓고 수수료를 알림톡으로 안내드립니다.</li>
						<li>고로켓고 수수료안내 (기본수수료 10,000원 + 송금액의 2.9%) 수수료 세금계산서발행 부가세별도</li>
						<li>도착한 USD 송금액은 현지은행 당일환율로 위안화 환전 후 현지은행수수료 제외한 실제금액을 고로켓고 회원님 계정으로 외환예치금으로 적립하여 드립니다.</li>
						<li>소액일 경우 발생수수료 환차손 등을 감안하면 대리결제를 추천하지 않습니다.</li>
						<li>결제 후 남은 외환예치금은 추후 사용가능하오니 여유있게 송금하실 것을 권장합니다.</li>
						<li>회원님의 위안화예치금은 고로켓고에서 위안화예치금의 안전을 보증합니다.</li>
						<li>최소 송금액은 $1,000, 최대 송금액은 $50,000 입니다. </li>
						<li>제조공장의 경우 회원님의 동의가 있어야 송금 가능하며 회원님 동의로 이미 송금 진행된 후에는 고로켓고에는 어떠한 책임도 없습니다.</li>
					</ul>
					<!-- <div class="btn-wrap">
						<div class="link-btn type-2" @click="goCustomsinfoUrl('https://blog.naver.com/postteam/223485584067')">
							대리결제 자세히보기 <i class="el-icon-top-right"></i>
						</div>
					</div> -->
				</div>	
			</div>
			<div class="unit mb100">
				<div class="title mb30">외환 예치금 환불규정</div>
				<div class="text-box">
					<ul class="dot-list">
						<li>송금일 +1일 이내에, 위안화로 환전 전, 송금액 전액을 환불 가능합니다.</li>
						<li>단,환불을 위한 발생 수수료 실비는 송금자 부담입니다.</li>
						<li>환불 요청시 이미 납입하신 모든 수수료는 환불 불가입니다.</li>
						<li>현지에 송금된 USD를 위안화로 환전후 회원님 계정에 위안화로 예치된 경우에는 환불이 불가 합니다 .</li>
						<li>외환 무역송금 이므로 고로켓고의 팀머니(구매/배송 예치금) 으로 변경 불가 합니다.</li>
						<li>모든 절차를 잘 검토/이해 하신후 신중한 진행하시기를 당부 드립니다.</li>
					</ul>
				</div>
			</div>
			
			<div class="mb100 text-center">
				대리결제 서비스는 사업자 회원만 이용하실 수 있습니다.
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	export default {
		components: {
			BusinessBanner,
		},
		data() {
			return{
				
			}
		},
		computed: {

		},		
		methods: {
			goCustomsinfoUrl(url){
				window.open(url, '_blank');
			},
		}
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.title-wrap .summary {
	    font-size: 17px;
	    line-height: 1.6;
	}
	.unit > .title {
	    font-weight: 700;
	    font-size: 30px;
	    line-height: 36px;
	    color: var(--frontground-color);
		padding: 0 10px;
	}
	.unit-list{
		display: flex;
		justify-content: space-between;
	}
	.type-card{
		margin:0 0 15px;
	}
	.type-card > .card-head {
		font-weight: 700;
		font-size: 20px;
		height: 66px;
		line-height: normal;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		gap: 0 8px;
		background: var(--secondary-color);
	}
	.unit .type-card {
	    border: 1px solid var(--border-color);
	    border-radius: 26px;
	    overflow: hidden;
	}
	.unit .type-card {
		flex: 1;
		box-shadow: none;
		filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
	}
	.unit .type-card .card-body {
	    padding: 10px;
	    height: 100%;
		background: #fff;
	}
	.type-card .img-box {
	    display: flex;
	    justify-content: center;
	}
	.type-card .card-body p {
	    text-align: left;
	    margin: 15px 0 0;
	    font-size: 12px;
	    line-height: 1.6;
	    color: #111111;
	    letter-spacing: -0.05em;
		text-align: center;
		height: 110px;
	}
	.unit .text-box {
	    padding: 50px;
	    background: #fff;
	    border: 1px solid #D9D9D9;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	    border-radius: 30px;
		margin: 0 10px;
	}
	.unit .text-box p {
	    font-weight: 500;
	    font-size: 17px;
	    line-height: 150%;
	    color: #000;
	}
	.unit .text-box .dot-list {
	    font-size: 15px;
	}
	ul.dot-list {
	    margin: 10px 0;
	    padding: 0;
	    list-style: none;
		color: var(--background-color);
	}
	ul.dot-list > li {
	    padding-left: 16px;
	    line-height: 30px;
	    position: relative;
	}
	ul.dot-list > li:before {
	    content: '';
	    display: block;
	    position: absolute;
	    top: 12px;
	    left: 0;
	    width: 6px;
	    height: 6px;
	    background: var(--main-color);
	    border-radius: 50%;
	}
	.btn-wrap{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.link-btn{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 13px 28px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	
	
	.mb30{
		margin-bottom: 30px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.mb100 {
	    margin-bottom: 100px !important;
	}
	.text-center {
	    text-align: center !important;
	}
	.visible-xs {
	    display: none !important;
	}

	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.unit-list{
			display: inherit;
		}
		.unit .text-box {
		    padding: 26px;
		}
		.type-card{
			margin:0 10px 15px;
		}
		.type-card .card-body p {
			height: auto;
			font-size: 13px;
			padding-bottom: 10px;
		}
	
	
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>